import React, { type ReactNode } from 'react';
import { SVG } from '../SVG';
import styles from './Error.module.sass';

interface ErrorProps {
  children: ReactNode;
}
// Component
const Error: React.FC<ErrorProps> = ({ children }) => {
  /* Display the error message */
  return (
    <div className={styles['error-mask']}>
      <div>
        <div className={styles['camera-icon-wrapper']}>
          <SVG withContainer={false} type="camera-icon" />
        </div>
        <div className={styles['text']}>{children}</div>
      </div>
    </div>
  );
};

export default Error;
